import React from 'react';
import PropTypes from 'prop-types';
import millify from 'utils/millify';
import { stripDecimalsAndFormat, calculatePercentage } from 'utils/misc';
import StatBar from 'components/StatBar';
import StatBarItem from 'components/StatBar/StatBarItem';
import { formatPotentialReach } from 'utils/report';
import { isEmpty } from 'lodash';

const CampaignStats = ({
  interestedSum,
  repliesSum,
  opensSum,
  totalDelivered,
  totalPeopleContacted,
  totalPeople,
  potentialReachSum,
  campaignCount,
}) => (
  <StatBar>
    {!isEmpty(campaignCount) && (
      <StatBarItem
        label="Campaigns"
        value={campaignCount}
      />
    )}
    <StatBarItem
      label="Total people"
      value={millify(totalPeople)}
      tooltip={stripDecimalsAndFormat(totalPeople)}
    />
    <StatBarItem
      label="Potential Reach"
      value={formatPotentialReach(potentialReachSum)}
      tooltip={stripDecimalsAndFormat(potentialReachSum)}
    />
    <StatBarItem
      label="Delivered"
      value={millify(totalDelivered)}
      tooltip={stripDecimalsAndFormat(totalDelivered)}
    />
    <StatBarItem
      label="Opens"
      value={`${calculatePercentage(totalPeopleContacted, opensSum)}%`}
      valueAffix={millify(opensSum)}
    />
    <StatBarItem
      label="Replies"
      value={`${calculatePercentage(totalPeopleContacted, repliesSum)}%`}
      valueAffix={millify(repliesSum)}
    />
    <StatBarItem
      label="Interested"
      value={`${calculatePercentage(totalPeopleContacted, interestedSum)}%`}
      valueAffix={millify(interestedSum)}
    />
  </StatBar>
);

CampaignStats.propTypes = {
  interestedSum: PropTypes.number.isRequired,
  repliesSum: PropTypes.number.isRequired,
  opensSum: PropTypes.number.isRequired,
  totalDelivered: PropTypes.number.isRequired,
  totalPeopleContacted: PropTypes.number.isRequired,
  totalPeople: PropTypes.number.isRequired,
  potentialReachSum: PropTypes.number.isRequired,
  campaignCount: PropTypes.number.isRequired,
};

export default CampaignStats;
